// store/slices/notificationsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification(state, action) {
      const incoming = action.payload;

      const existingIndex = state.notifications.findIndex(
        (n) => n.id === incoming.id
      );

      if (existingIndex === -1) {
        state.notifications.push(incoming);
        return;
      }

      state.notifications[existingIndex] = incoming
    },
    removeNotification(state, action) {
      state.notifications = state.notifications.filter((notif) => notif.id !== action.payload);
    },
    clearNotifications(state) {
      state.notifications = [];
    },
  },
});

export const { addNotification, removeNotification, clearNotifications } = notificationsSlice.actions;
export default notificationsSlice.reducer;
